export default __webpack_public_path__ + "static/media/expand_more-default.c633f770.svg";